import FunnelsService from '@/services/FunnelsService.js'
import jwt from '@/helpers/jwtHelper'

export default {
  getFeatures({ commit, state }) {
    const domain = jwt.payload.tenant.domains[jwt.payload.tenant.domains.length - 1]
    return FunnelsService.getParams(domain).then(({ data }) => {
      commit('setFeatures', data.features)
    })
  },
}
